<template>
  <v-dialog
    v-model="dialogUserEdit"
    persistent
    scrollable
     width="880" height="620px"
  >
    <v-card class="popup add_store_popup">
      <v-card-title>
      <h3 class="page-title-bar">
        <i class="ico ico-user"></i>
        {{ $t('User Edit') }}
      </h3>
      </v-card-title>
      <v-card-text>

      <div>
        <v-row>
          <v-col>
            <v-text-field
              outlined
              dense
              hide-details
              :label="`${$t('ID')} *`"
              :placeholder="$t('Input the ID')"
              :value="item.account"
              class="form-input"
              disabled
              clearable
               @keydown="clearTabindex"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-if="userEditPassword===true"
              outlined
              dense
              hide-details
              :label="`${$t('Password')} *`"
              type="Password"
              v-model="password"
              @input="passwordValidate"
              class="form-input"
              clearable
            ></v-text-field>
          </v-col>
        </v-row>

        <div v-if="passwordPolicy">
          <br>
        <span style="color: #001e38;font-size:14px">Password Rules <span style="color: red;">*</span></span>
            <v-row style="margin-top: 5px;">
              <v-col class="cols-6">
                <span class="popup-titbox mb-0" style="display: flex;flex-direction: column;">
                  <p class="frmValidation"><v-icon class="mr-4"
                      :class="{ iconClassNot: !has_length, iconClass: has_length }">mdi-checkbox-marked-circle</v-icon>Contains
                    8 to 15 characters.</p>
                  <p class="frmValidation mt-3"><v-icon class="mr-4"
                      :class="{ iconClassNot: !has_uppercase, iconClass: has_uppercase }">mdi-checkbox-marked-circle</v-icon>Include
                    at least 1 uppercase letter.</p>
                  <p class="frmValidation mt-3"><v-icon class="mr-4"
                      :class="{ iconClassNot: !has_lowercase, iconClass: has_lowercase }">mdi-checkbox-marked-circle</v-icon>Include
                    at least 1 lower case letter.</p>
                  <p class="frmValidation mt-3"><v-icon class="mr-4"
                      :class="{ iconClassNot: !has_number, iconClass: has_number }">mdi-checkbox-marked-circle</v-icon>Include
                    at least 1 number.</p>
                  <p class="frmValidation mt-3"><v-icon class="mr-4"
                      :class="{ iconClassNot: has_userid, iconClass: !has_userid }">mdi-checkbox-marked-circle</v-icon>Password
                    should not contains the user_id</p>
                </span>
              </v-col>
              <v-col grow>
                <p class="frmValidation"><v-icon class="mr-4"
                    :class="{ iconClassNot: !has_special, iconClass: has_special }">mdi-checkbox-marked-circle</v-icon>Include
                  at least 1 special character.<br />
                  <span style="font-size: 14px;margin-left: 34px;">(*List all special characters and not just
                    etc)</span>
                </p>
                <p class="frmValidation mt-3"><v-icon class="mr-4"
                    :class="{ iconClassNot: has_consicutive, iconClass: !has_consicutive }">mdi-checkbox-marked-circle</v-icon>Not
                  use 3 consecutive characters. (abc, 123)</p>
                  <p class="frmValidation mt-3"><v-icon class="mr-4"
                    :class="{ iconClassNot: has_consecutive_keyboard, iconClass: !has_consecutive_keyboard }">mdi-checkbox-marked-circle</v-icon>Not
                  use 3 consecutive keyboard characters. (qwe, !23)</p>
                <p class="frmValidation mt-3"><v-icon class="mr-4"
                    :class="{ iconClassNot: has_repeat, iconClass: !has_repeat }">mdi-checkbox-marked-circle</v-icon>Not
                  repeat 3 characters. (aaa, 777)</p>
                <p class="frmValidation mt-3"><v-icon class="mr-4"
                    :class="{ iconClassNot: !has_space, iconClass: has_space }">mdi-checkbox-marked-circle</v-icon>Not
                  use
                  space.</p>
              </v-col>
            </v-row>
          </div>
        <v-row>
          <v-col>
            <p class="label-txt">{{ $t('Permission Level') }} *</p>
          <v-radio-group
            v-model="item.accessLevel"
            dense
            hide-details
            row
          >
            <v-radio
              v-for="levelItem in accessLevelItems"
              :key="levelItem.level"
              :value="levelItem.level"
              :label="levelItem.name"
              :disabled="getAccessLevelDisabled(levelItem.level)"
              style="margin-right: 15px;padding:8px"
              class="form-radio flat"
            />
          </v-radio-group>
          </v-col>
        </v-row>
      </div>
      <div>
        <v-row>
          <v-col cols="6">
            <v-text-field
              v-model="name"
              :label="`${$t('Name')} *`"
              :placeholder="$t('Input the name')"
              class="form-input"
              outlined
              dense
              hide-details
              clearable
               @keydown="clearTabindex"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-model="email"
              :label="`${$t('Email Address')} *`"
              :placeholder="$t('Input the email address')"
              class="form-input"
              outlined
              dense
              hide-details
              clearable
               @keydown="clearTabindex"
            ></v-text-field>
          </v-col>
          <!-- 삭제
          <v-col>
            <v-text-field outlined dense hide-details
              label="Phone Number"
              placeholder="Input the phone number"
              class="form-input"
              v-model="phoneNumber"
            ></v-text-field>
          </v-col>
           -->
        </v-row>
      </div>
    </v-card-text>
      <div>
        <v-card-actions class="d-flex justify-center">
          <v-btn
            :disabled="userSaveDisabled || userSaveDisabledAction"
            @click="clickSave"
            text
            icon
            class="btn"
          >{{ $t('Save') }}
          </v-btn>
          <v-btn
            text
            icon
            @click="closeModal"
            class="btn"
          >{{ $t('Cancel') }}
          </v-btn>
        </v-card-actions>
      </div>

    </v-card>
  </v-dialog>
</template>

<script>
import EventBus from '@/plugins/eventBus'
import codes from '@/plugins/codes'
import commons from '@/plugins/commons'
import { getEmailValidation } from '@/plugins/passwordValidator'

const requests = {
  passwordchange: {
    method: 'put',
    url: '/api/common/account/password/temporary'
  }
}
export default {
  props: [
    'dialogUserEdit',
    'accessLevelItems',
    'userAccessLevel'
  ],
  data () {
    return {
      accessLevel: null,
      password: null,
      name: null,
      phoneNumber: null,
      email: null,
      emailAlarm: false,
      emailReport: false,
      item: {
        account: '',
        accessLevel: '',
        firstName: '',
        emailAddress: ''
      },

      userSaveDisabled: false,
      userEditPassword: false,
      initValue: {
        emailAddress: '',
        firstName: '',
        accessLevel: ''
      },
      // Password Rules
      dialog_passwordChange: false,
      confirmpassword: '',
      has_length: false,
      has_number: false,
      has_lowercase: false,
      has_uppercase: false,
      has_special: false,
      has_consicutive: false,
      has_consecutive_keyboard: false,
      has_repeat: false,
      has_space: true,
      has_userid: false,
      savebutton: false,
      passwordPolicy: false
      // end
    }
  },
  computed: {
    userSaveDisabledAction () {
      return !(
        (this.password && this.password !== '') ||
      this.email !== this.initValue.emailAddress ||
      this.name !== this.initValue.firstName ||
      this.item.accessLevel !== this.initValue.accessLevel
      )
    }

  },
  methods: {
    clearTabindex () {
      var elements = document.getElementsByClassName('v-icon')
      for (let i = 0; i < elements.length; i++) {
        elements[i].setAttribute('tabindex', '-1')
      }
    },
    getAccessLevelDisabled (accessLevel) {
      return (Number(accessLevel) <= Number(this.userAccessLevel))
    },
    closeModal () {
      this.$emit('closeModal', false)
    },
    refreshUserInfo () {
      this.closeModal()
      this.$emit('updateUserInfo')
    },
    checkUserInfoValidation (password, email) {
      const emailValidation = getEmailValidation(email)
      if (emailValidation.result === false) {
        EventBus.$emit('messageAlert', this.$t(emailValidation.msg))
        return false
      }
      return true
    },
    clickSave () {
      if (commons.isValidStr(this.email)) this.email = this.email.trim(' ') // 값이 있는경우 trim
      if (this.checkUserInfoValidation(this.password, this.email) === false) return // 빈값이 아닌경우 유효성검사
      if (this.password === null) this.password = '' // null 인경우 API요청할 수 없으므로, ''로 교체
      if (this.email === null) this.email = '' // null 인경우 API요청할 수 없으므로, ''로 교체
      if (this.email === null || this.email === '') {
        EventBus.$emit('messageAlert', this.$t('The user information is invalid.'))
        return false
      }
      if (this.name === null || this.name === '') {
        EventBus.$emit('messageAlert', this.$t('The user information is invalid.'))
        return false
      }
      const config = {
        params: {
          company: this.$store.state.auth.user.company,
          myAccessLevel: this.userAccessLevel
        }
      }
      if (this.password !== '' && (this.email !== this.initValue.emailAddress || this.name !== this.initValue.firstName || this.initValue.accessLevel !== this.item.accessLevel)) {
        this.passwordchangeBoth()
      } else if (this.password !== '') {
        this.passwordchange()
      } else if (this.email !== this.initValue.emailAddress || this.name !== this.initValue.firstName || this.initValue.accessLevel !== this.item.accessLevel) {
        const body = {
          account: this.item.account,
          password: this.password,
          firstName: this.name,
          emailAddress: this.email,
          emailAlarm: this.emailAlarm,
          emailReport: this.emailReport,
          accessLevel: this.item.accessLevel
        }
        this.$utils
          .callAxiosWithBody(
            codes.requests.editUser.method,
            codes.requests.editUser.url,
            body,
            config
          )
          .then(res => {
            if (res.data.responseCode === '200') {
              EventBus.$emit('messageAlert', this.$t(res.data.responseMessage))
              this.refreshUserInfo()
            }
          })
          .catch(error => {
            console.debug(`Failed to edit the user information. error: ${error}`)
            EventBus.$emit('messageAlert', this.$t(error.response.data.responseMessage))
          })
      }
    },
    passwordchange () {
      const config = { params: {} }
      const body = {
        account: this.item.account,
        newPassword: this.password
      }
      this.$utils
        .callAxiosWithBody(
          requests.passwordchange.method,
          requests.passwordchange.url,
          body,
          config
        )
        .then(res => {
          if (res.data.responseCode === '200') {
            EventBus.$emit('messageAlert', this.$t(res.data.responseMessage))
            this.refreshUserInfo()
          }
        })
        .catch(error => {
          console.debug(`Failed to edit the user information. error: ${error}`)
          EventBus.$emit('messageAlert', this.$t(error.response.data.responseMessage))
          this.dialogUserEdit = true
        })
    },
    passwordchangeBoth () {
      const config = { params: {} }
      const body = {
        account: this.item.account,
        newPassword: this.password
      }
      this.$utils
        .callAxiosWithBody(
          requests.passwordchange.method,
          requests.passwordchange.url,
          body,
          config
        )
        .then(res => {
          if (res.data.responseCode === '200') {
            this.tosavedetails()
          }
        })
        .catch(error => {
          console.debug(`Failed to edit the user information. error: ${error}`)
          EventBus.$emit('messageAlert', this.$t(error.response.data.responseMessage))
          this.dialogUserEdit = true
        })
    },
    tosavedetails () {
      const config = {
        params: {
          company: this.$store.state.auth.user.company,
          myAccessLevel: this.userAccessLevel
        }
      }
      const body = {
        account: this.item.account,
        password: this.password,
        firstName: this.name,
        emailAddress: this.email,
        emailAlarm: this.emailAlarm,
        emailReport: this.emailReport,
        accessLevel: this.item.accessLevel
      }
      this.$utils
        .callAxiosWithBody(
          codes.requests.editUser.method,
          codes.requests.editUser.url,
          body,
          config
        )
        .then(res => {
          if (res.data.responseCode === '200') {
            EventBus.$emit('messageAlert', this.$t(res.data.responseMessage))
            this.refreshUserInfo()
          }
        })
        .catch(error => {
          console.debug(`Failed to edit the user information. error: ${error}`)
          EventBus.$emit('messageAlert', this.$t(error.response.data.responseMessage))
        })
    },
    getMyInfo () {
      const config = {
        params: {
          company: this.$store.state.auth.user.company,
          account: this.item.account
        }
      }
      this.$utils.callAxios(
        codes.requests.getUserDetail.method,
        codes.requests.getUserDetail.url,
        config
      ).then(res => {
        if (res.data) {
          this.initValue = {
            emailAddress: res.data.emailAddress,
            firstName: res.data.firstName,
            accessLevel: res.data.accessLevel
          }

          this.item.accessLevel = res.data.accessLevel
          this.item.firstName = res.data.firstName
          this.item.emailAddress = res.data.emailAddress

          this.email = res.data.emailAddress
          this.emailAlarm = res.data.emailAlarm
          this.emailReport = res.data.emailReport
          this.phoneNumber = res.data.phoneNumber
          this.name = res.data.firstName
        }
      })
    },
    initData () {
      this.password = null
      this.name = null
      this.phoneNumber = null
      this.email = null
      this.emailAlarm = false
      this.emailReport = false
    },
    passwordValidate () {
      // Length 8 to 15
      if (this.password.length > 7 && this.password.length < 16 && this.password.length !== 0) {
        this.has_length = true
      } else {
        this.has_length = false
      }
      // Upper Case
      this.has_uppercase = /[A-Z]/.test(this.password)

      // Lower Case
      this.has_lowercase = /[a-z]/.test(this.password)

      // One Number
      this.has_number = /\d/.test(this.password)

      // Special Characters
      // eslint-disable-next-line
      this.has_special = /[!@#\$%\^\&*\)\(+=._-]/.test(this.password)

      // Consective Characters
      this.has_consicutive = /(abc|bcd|cde|def|efg|fgh|ghi|hij|ijk|jkl|klm|lmn|mno|nop|opq|pqr|qrs|rst|stu|tuv|uvw|vwx|wxy|xyz|012|123|234|345|456|567|678|789)/.test(this.password)

      // Consecutive Keyboard Characters Sequences
      this.has_consecutive_keyboard = /(qwe|wert|ert|rty|tyu|yui|uio|iop|asd|sdf|dfg|fgh|ghj|hjk|jkl|zxc|xcv|cvb|vbn|bnm|!23|@#4|$%5|^&6)/.test(this.password)
      // Repeat
      this.has_repeat = /(.)\1\1/.test(this.password)

      // Space
      this.has_space = /^\S+$/.test(this.password)

      // User Id
      this.has_userid = this.password.toLowerCase().includes(this.item.account.toLowerCase())
      if (this.has_length && this.has_number && this.has_lowercase && this.has_uppercase && this.has_special && !this.has_consicutive && !this.has_consecutive_keyboard && !this.has_repeat && this.has_space && !this.has_userid) {
        this.savebutton = true
      } else {
        this.savebutton = false
      }
    }
  },
  mounted () {
    if (this.$store.state.auth.user.accountInfo.accessLevel === '1') {
      this.userEditPassword = true
    }
    if (this.$store.state.auth.user.pwPolicyEnable === 'true') {
      this.passwordPolicy = true
    }
    EventBus.$on('openUserInfoEditPopup', (item) => {
      Object.assign(this.item, item)
      this.initData()
      this.getMyInfo()
    })
    this.$store.dispatch('auth/getDisabledBtn', '8100').then((flag) => {
      this.userSaveDisabled = flag
    })
    console.log(this.$store.state.auth.user.accountInfo.accessLevel)
  },
  beforeDestroy () {
    EventBus.$off('openUserInfoEditPopup')
  }
}
</script>
<style scoped>
/* Scroll bar stylings */
::v-deep ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  /* Track */
  ::v-deep ::-webkit-scrollbar-track {
    background: var(--lightestgrey);
  }

  /* Handle */
  ::v-deep ::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 5px;
  }

  /* Handle on hover */
  ::v-deep ::-webkit-scrollbar-thumb:hover {
    background: #c1c1c1;
  }
  ::v-deep .v-data-table__wrapper::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 5px;
    }
    .iconClassNot {
  color: lightgrey !important;
}

.iconClass {
  color: #6D9852 !important;
}

.frmValidation {
  font-size: 12px;
}
</style>
